<template>
  <div class="personaldata">
    <van-nav-bar title="个人资料" fixed placeholder left-arrow @click-left="onClickLeft" />

    <van-form @submit="Updateinformation()" label-width='1.5rem' label-align='center' class="profile">

      <van-field v-model="information.phone" label="手机号" placeholder="请输入手机号"
        :rules="[{ pattern: rules.phoneRules, message: '手机格式不正确'  }]" />

      <van-field v-model="information.tel" label="座机号" placeholder="请输入座机号"
        :rules="[{validator, message: '座机格式不正确' }]" />

      <van-field name="uploader" label="头像" class="back-tran">
        <template #input>
          <van-uploader v-model="fileList" :after-read="afterRead" @delete="delImage" multiple :max-count="1" />
          <div style="display: inline-block;">
            <span class="chicun">图片尺寸：</span>
            <br />
            <span class="chicun">110 x 110px</span>
          </div>
        </template>
      </van-field>

      <van-field name="uploader" label="二维码" class="back-tran">
        <template #input>
          <van-uploader v-model="fileLists" :after-read="afterReads" @delete="delErweima" multiple :max-count="1" />
          <div style="display: inline-block;">
            <span class="chicun">图片尺寸：</span>
            <br />
            <span class="chicun">110 x 110px</span>
          </div>
        </template>
      </van-field>

      <van-button type="primary" block color="#2DADB1" native-type="submit">提交</van-button>
    </van-form>
  </div>
</template>

<script>
import { updateUserPhoto, updateUserProfile, adminInfo } from '@/api/user.js'
export default {
  name: 'personaldata',
  components: {},
  props: {},
  data () {
    return {
      fileList: [],
      fileLists: [],
      information: {
        phone: '',
        tel: '',
        image: null,
        erweima: null
      },
      rules: {
        phoneRules: /^1[3456789]\d{9}$/,
        telRules: /^([0-9]{3,4}-)?[0-9]{7,8}$/
      }
    }
  },
  mounted () { this.getadminInfo() },
  methods: {
    // 获取个人信息
    async getadminInfo () {
      const data = await this.$store.state.userInfo
      for (const key in this.information) {
        this.information[key] = data[key]
      }
      if (data.image) {
        this.fileList.push({ url: this.$base + data.image })
      }
      if (data.erweima) {
        this.fileLists.push({ url: this.$base + data.erweima })
      }
    },
    // 校验座机是否正确
    validator (val) {
      if (val == '') {
        return true
      } else {
        return this.rules.telRules.test(val)
      }
    },
    // 修改个人资料
    async Updateinformation () {
      const indata = this.information
      if (
        indata.phone === '' ||
        indata.tel === ''
      ) {
        return this.$toast('请完善信息')
      } else {
        const data = await updateUserProfile(this.information)
        if (data.error_code === 1) {
          this.$toast('修改成功')
          this.getpersonaldata()
          setTimeout(() => {
            this.$router.back()
          }, 2000)
        } else {
          this.$toast('操作失败')
        }
      }
    },
    // 重新获取用户信息
    async getpersonaldata () {
      try {
        const { data } = await adminInfo()
        this.$store.commit('setUserInfo', data)
      } catch (error) {
        return error.message
      }
    },
    // 上传头像
    async afterRead (file) {
      const { data, error_code } = await updateUserPhoto('files', file.file)
      if (error_code === 1) {
        this.information.image = data
      } else {
        this.$toast('操作失败')
      }
    },
    // 上传二维码
    async afterReads (file) {
      const { data, error_code } = await updateUserPhoto('files', file.file)
      if (error_code === 1) {
        this.information.erweima = data
      } else {
        this.$toast('操作失败')
      }
    },
    // 取消头像预览图片
    delImage () {
      this.information.image = ''
    },
    // 取消二维码预览图片
    delErweima () {
      this.information.erweima = ''
    },
    onClickLeft () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.personaldata {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;

  .profile {
    width: 90%;
    margin: 60px auto 0;
  }
  /deep/ .van-button--block {
    width: 500px;
    margin: 80px auto;
  }
}
</style>
